<div class="kpi-card" [class.kpi-card--destaque]="destaque">
  <div class="kpi-card__header">
    <h3 class="kpi-card__title">{{ title }}</h3>
    <span
      class="kpi-card__icon kpi-card__icon--{{ iconVariant }}"
      aria-hidden="true"
    >
      <span class="material-icons">{{ icon }}</span>
    </span>
  </div>
  <p
    class="kpi-card__value"
    [class.kpi-card__value--success]="valueTone === 'success'"
    [class.kpi-card__value--default]="valueTone === 'default'"
  >
    {{ value }}
  </p>
  <p
    class="kpi-card__subtitle"
    [class.kpi-card__subtitle--danger]="subtitleTone === 'danger'"
    [class.kpi-card__subtitle--muted]="subtitleTone === 'muted'"
    *ngIf="subtitle"
  >
    {{ subtitle }}
  </p>
</div>
